import './styles/main.css';
import './styles/piel-theme.css';

import { renderNav } from './components/nav.js';
import { initPixelBg } from './components/pixel-bg.js';
import { initRouter } from './router';
import { tryAutoReconnect } from './wallet.js';
import { initTelemetry } from './telemetry.js';

async function init(): Promise<void> {
  initTelemetry();
  initPixelBg();

  const navContainer = document.getElementById('nav');
  const appContainer = document.getElementById('app');
  if (!(navContainer instanceof HTMLElement) || !(appContainer instanceof HTMLElement)) {
    throw new Error('Missing root app containers.');
  }

  renderNav(navContainer);
  tryAutoReconnect().catch(() => {});
  initRouter(appContainer);
}

void init();
